module.exports = __webpack_public_path__ + "img/whl (2).0400787e.png";